import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { paymentModule } from "../api/modules/payment.module";

// Query key factory
export const payoutKeys = {
  all: ["payouts"],
  lists: () => [...payoutKeys.all, "list"],
  list: (params) => [...payoutKeys.lists(), params],
};

// Hook to fetch payouts list
export const usePayouts = (params = {}) => {
  return useQuery({
    queryKey: payoutKeys.list(params),
    queryFn: async () => {
      const response = await paymentModule.getPayoutsList(params);
      if (!response.success) {
        throw new Error(response.message);
      }
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
};

// Hook to request payout
export const useRequestPayout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      const response = await paymentModule.requestPayout(payload);
      if (!response.success) {
        throw new Error(response.message);
      }
      return response.data;
    },
    onSuccess: () => {
      // Invalidate and refetch payouts list
      queryClient.invalidateQueries({ queryKey: payoutKeys.lists() });
    },
  });
};

// Hook to review payout (approve/reject)
export const useReviewPayout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      const response = await paymentModule.reviewPayout(payload);
      if (!response.success) {
        throw new Error(response.message);
      }
      return response.data;
    },
    onSuccess: () => {
      // Invalidate and refetch payouts list
      queryClient.invalidateQueries({ queryKey: payoutKeys.lists() });
    },
  });
};
